import { Navigate, Outlet, useLocation } from 'react-router-dom';
import TRCHeader from './components/header';
import { useAtomValue } from 'jotai';
import { userInfoAtom } from '@/data/atoms/utilsAtoms';
import { shouldShowStudioHub } from '@/utils/isStudioUser';
import { TRC_ROUTES } from '@/TRC/constants/trcRoutes';

const TRCLayout = () => {
	const { pathname, search, hash } = useLocation();
	const userData = useAtomValue(userInfoAtom);
	const isStudioHub = shouldShowStudioHub(userData);
	const isTRCPath = pathname.startsWith(TRC_ROUTES.TRC_HOME);
	const isStudioHubPath = pathname.startsWith(TRC_ROUTES.STUDIO_HUB_HOME);

	if (isStudioHub && isTRCPath) {
		return <Navigate to={`${pathname.replace(TRC_ROUTES.TRC_HOME, TRC_ROUTES.STUDIO_HUB_HOME)}${search}${hash}`} replace />;
	}

	if (!isStudioHub && isStudioHubPath) {
		return <Navigate to={`${pathname.replace(TRC_ROUTES.STUDIO_HUB_HOME, TRC_ROUTES.TRC_HOME)}${search}${hash}`} replace />;
	}

	return (
		<>
			<TRCHeader />
			<Outlet />
		</>
	);
};

export default TRCLayout;